import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Trophy, Users, Globe } from 'lucide-react';

function formatNumber(value) {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
  return value.toString();
}

export default function StarPlayers({ roster }) {
  if (!roster) return null;
  
  const players = roster.star_players || [];
  
  return (
    <Card className="bg-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="w-4 h-4" />
          Top Players by Brand Score
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-3 gap-4 mb-4">
          <div className="text-center p-3 rounded bg-muted/30">
            <Users className="w-6 h-6 mx-auto mb-1 text-primary" />
            <p className="text-2xl font-bold">{roster.total_players}</p>
            <p className="text-xs text-muted-foreground">Total Players</p>
          </div>
          <div className="text-center p-3 rounded bg-muted/30">
            <Trophy className="w-6 h-6 mx-auto mb-1 text-green-500" />
            <p className="text-2xl font-bold">{roster.players_with_1m_plus_followers}</p>
            <p className="text-xs text-muted-foreground">Stars (1M+)</p>
          </div>
          <div className="text-center p-3 rounded bg-muted/30">
            <Globe className="w-6 h-6 mx-auto mb-1 text-primary" />
            <p className="text-2xl font-bold">{formatNumber(roster.aggregate_player_reach)}</p>
            <p className="text-xs text-muted-foreground">Aggregate Reach</p>
          </div>
        </div>
        <div className="space-y-2">
          {players.slice(0, 5).map((p, i) => (
            <div key={i} className="flex items-center justify-between p-3 rounded bg-muted/30">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center font-bold text-primary">
                  {i + 1}
                </div>
                <div>
                  <p className="font-medium">{p.name}</p>
                  <p className="text-sm text-muted-foreground">{formatNumber(p.instagram_followers)} followers</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-xl font-bold">{p.brand_score}</p>
                <p className="text-xs text-muted-foreground">Brand Score</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
